module.exports = __webpack_public_path__ + "img/401.129f9c73.png";